'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function pick(obj, keys) {
    var result = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (Object.hasOwn(obj, key)) {
            result[key] = obj[key];
        }
    }
    return result;
}
exports.pick = pick;
